import React from 'react'
import "./ChinaHotels.scss"
import Topbar from '../../components/TopbarChina/Topbar'
import Footer from "../../components/Footer/Footer"
import ToursSlider from '../../components/ToursSlider/ToursSlider';
import hotels from './hotelsData'

const ChinaHotels = () => {
  return (
    <div className='hotels-box'>
      <Topbar bgColor={true}/>
      <ToursSlider hotels={hotels}/>
      <Footer/>
    </div>
  )
}

export default ChinaHotels
